import lodash from 'lodash'
export default {
  register: state =>  state.register,
  login: state =>  state.login,
  token: state =>  state.token.value,
  shopsInfo: state =>  state.token.data && state.token.data.shopsInfo && state.token.data.shopsInfo.length > 0 ? _.first(state.token.data.shopsInfo) : null,
  verifyPhoneNumber: state =>  state.verifyPhoneNumber,
  isAuthenticated: state => state.isAuthenticated,
  redirectAfterAuth: state => state.redirectAfterAuth
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/auth/getters.js
// module id = null
// module chunks = 